import React from 'react';
import { isEqual } from '../../../services/utils';
import tableStore from '../../../store/tableStore';
import { Col, Row, Button } from 'react-bootstrap'
import { FaCheckCircle } from "react-icons/fa";
import { publishData } from '../../../services/publishData';
import { withRouter } from "react-router";
import userStore from '../../../store/userStore';
import treeStore from '../../../store/treeStore';
import { FaRegSave, FaCloud } from 'react-icons/fa';


/**Displays the page title
 * Also checks if the trees are different each time something new updates
 * it can sometimes through false positives
 */
class TitleChanger extends React.Component {
    constructor(props) {
        super();
        this.state = {
            title: tableStore.table.name,
            showTitle: true,
            loading: false,
            ogTree: undefined,
            needsSaving: false
        }
    }
    componentWillMount() {
        // getTreeFromDb(table)
        tableStore.on("Table-Changes", this.titleSetter);
        treeStore.on("Tree-Changes", this.compareTree)
        treeStore.on("Set-Tree", this.setOgTree);
        if(treeStore.tree !== undefined || treeStore.tree !== null || treeStore.tree !== {}){
            this.setOgTree();
        }
        this.titleSetter();
    }
    componentDidMount() {
    }
    /**Checks the keys of the table to try determine if there were any updates */
    compareTree = () => {
        const { ogTree } = this.state;
        if (ogTree) {
            const ogKeys = Object.keys(ogTree);
            const treeKeys = Object.keys(treeStore.tree);
            if (ogKeys.length !== treeKeys.length) {
                if (!this.state.needsSaving) {
                    this.setState({ needsSaving: true });
                }
                return;
            } else {
                const equal = isEqual(ogKeys, treeKeys);
                if (!equal) {
                    if (!this.state.needsSaving) {
                        this.setState({ needsSaving: true });
                    }
                    return;
                } else {
                    if (this.state.needsSaving) {
                        this.setState({ needsSaving: false });
                    }
                    return;
                }
            }
        }
    }
    componentWillUnmount() {
        tableStore.removeListener("Table-Changes", this.titleSetter);
        treeStore.removeAllListeners();
    }
    titleSetter = () => {
        // console.log()

        this.setState({ title: tableStore.table.name });
    }
    setOgTree = () => {
        const ogTree = JSON.parse(JSON.stringify(treeStore.tree));
        this.setState({ ogTree: ogTree });
    }
    completedClick = () => {
        if (window.confirm("Have you completed the tree?")) {
            this.setState({ loading: true }, () => {
                publishData(true).then(() => {
                    this.setState({ loading: false });
                    this.props.history.push("/home");
                })
            })
        }
    }
    render() {
        const { loading, needsSaving } = this.state;
        return (
            <div className="title" >
                <div>
                    <h3 onClick={this.titleChanger}>{this.state.title}</h3>
                    <Row>
                        <Col xs={5}>
                            {needsSaving ? <p> <b><FaRegSave /> Changes detected please save...</b></p> : <p><FaCloud /> No changes detected</p>}

                        </Col>
                        <Col xs={2} className="pull-left">
                            {userStore.user.stage <= 2 ?
                                <Button className="pull-left" disabled={loading}
                                    variant="success" onClick={!loading ? this.completedClick : null}>
                                    {loading ? "Loading..." : <span> <FaCheckCircle />  Sign off tree </span>}
                                </Button> : null}
                        </Col>
                    </Row>

                </div>
            </div>
        )
    }

}
export default withRouter(TitleChanger);


// WEBPACK FOOTER //
// ./src/components/tree/treeHeader/TitleChanger.js